module.exports = __webpack_public_path__ + "media/images/powered_by_useek-68388db0f5c0f6f9caa6f045dfdc59c0.png";